import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import { presQuestion2026Mixin } from "./vue/mixins/pres-questions-2026";
import lazyload from "./features/lazy-load";

const mixins = [];
mixins.push(presQuestion2026Mixin);
initMain(mixins, {});
header();

lazyload();
